import { Box, Typography } from '@mui/material'
import { t } from 'i18next'
import { Trans } from 'react-i18next'
import GoToBox from '../components/GoToBox/GoToBox'
import React, { useMemo } from 'react'
import { useAppDispatch, useAppSelector } from '../../../store/utils/hooks'
import { actionSaveImportStep } from '../../../store/slices/import/importSlice'
import { ImportStep } from '../../../store/slices/import/types/types'
import useSearchCampaign from '../../../api/campaign/useSearchCampaign'
import PreviewList from '../components/PreviewList/PreviewList'
import { selectUserData } from '../../../store/slices/user/userSlice'

export default function HomeDetails() {
	const dispatch = useAppDispatch()
	const { data: userData } = useAppSelector(selectUserData)
	const { campaigns, isFetchingResults, pagination } = useSearchCampaign('home-campaigns', {
		page_size: 3,
		page_number: 1,
		sort_order: 'desc',
		sort_by: 'created_at',
	})

	const message = useMemo(
		() =>
			isFetchingResults
				? t('home.card.existing_campaign_loading')
				: t('home.card.existing_campaign_subtitle', {
						total_campaign_count: pagination.totalRecords,
					}),
		[isFetchingResults, pagination.totalRecords],
	)

	return (
		<Box sx={{ mr: '32px' }}>
			<Typography variant="h1">
				<span style={{ textTransform: 'capitalize' }}>
					<Trans i18nKey="home.title.user_greetings" values={{ username: userData.firstName }} />
				</span>
			</Typography>
			<Typography sx={{ lineHeight: '24px', fontSize: '14px' }}>
				<Trans i18nKey="home.title.welcome_message" components={{ br: <br /> }} />
			</Typography>
			<Typography variant="h3" sx={{ mt: '64px' }}>
				<Trans i18nKey="home.subtitle_1" />
			</Typography>
			<Box>
				<GoToBox
					title={t('home.card.new_campaign_title')}
					subtitle={t('home.card.new_campaign_subtitle')}
					to="/create-campaign"
					onClick={() => dispatch(actionSaveImportStep(ImportStep.CREATE_CAMPAIGN))}
					sx={{ mt: '18px' }}
				/>
				<GoToBox
					title={t('home.card.existing_campaign_title')}
					subtitle={message}
					to="/campaign-manager"
					sx={{ mt: '18px' }}
				/>
			</Box>
			<Box>
				<PreviewList campaigns={campaigns} isLoading={isFetchingResults} />
			</Box>
		</Box>
	)
}
